export const MONITORING_TAGS = {
  API_ERROR: 'API_ERROR',
  ANALYTICS: 'ANALYTICS',
  MEMBERS: 'MEMBERS',
  MARKETING: 'MARKETING',
  AUTH: 'AUTH',
  CHECKOUT: 'CHECKOUT',
  UNIFIED_CHECKOUT: 'UNIFIED_CHECKOUT',
  SHIPMENT: 'SHIPMENT',
  PAYMENT: 'PAYMENT',
  ORDER_REVIEW: 'ORDER_REVIEW',
  CART: 'CART',
  SHOP: 'SHOP',
  BUILD_A_BUNDLE: 'BUILD_A_BUNDLE',
  REBILL: 'REBILL',
  PLACE_ORDER: 'PLACE_ORDER',
  FETCH_PRODUCTS: 'FETCH_PRODUCTS',
  PROMOCODE: 'PROMOCODE',
  BACKGROUND_ASYNC_TASKS: 'BACKGROUND_ASYNC_TASKS',
  FREE_GIFTS: 'FREE_GIFTS',
  QUIZ: 'QUIZ',
  UPSCRIBE: 'UPSCRIBE',
  SANITY_CONTENT: 'SANITY_CONTENT'
} as const;

export type MonitoringTag = (typeof MONITORING_TAGS)[keyof typeof MONITORING_TAGS];
